import React, { useState, useEffect, Fragment } from "react";

const useAttributeTable = (
    attributeArray,
    designations,
    handleDelAttribute,
    handleEditAttribute,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Attribute","Description","Designation","Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = attributeArray.map((el) => {
      var temp = new Array();
      temp = el.designation.split(",");
      let newarr=[];
      temp.map(function (id) { designations.map(function (desId) {
        if(desId.designationId == parseInt(id))
        {
          newarr.push({val:desId.designationName});
        }
      })});
      const deprt=newarr.map(item => item.val).join(', ');

      return {
        "Attribute": el.attribute,
        "Description": el.description,
        "Designation":deprt,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"              
              onClick={() => {
                handleEditAttribute(el, el.atrributeId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelAttribute(el)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    attributeArray,
    handleDelAttribute,
    handleEditAttribute,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useAttributeTable;